import styled from 'styled-components';
const Spacer = styled.div.withConfig({
  shouldForwardProp: p => !['vertical', 'size'].includes(p)
})`
  ${({
  theme,
  size,
  vertical
}) => vertical ? `
        width: ${theme.size[size]};
        height: 100%;
        ` : `
        height: ${theme.size[size]};
        width: 100%;
      `}
`;
export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
